<template>
	<div>
		<el-form label-width="120px" ref="post" :model="post" :rules="rules">
			<el-form-item label="登陆账号" prop="username" >
				<el-input placeholder="登陆账号" v-model.trim="post.username" class="w-200"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="password" >
				<el-input placeholder="密码" v-model="post.password" class="w-200"></el-input>
			</el-form-item>
			<el-form-item label="真实姓名" prop="realname" >
				<el-input placeholder="真实姓名" v-model="post.realname" class="w-200"></el-input>
			</el-form-item>
			<el-form-item label="手机号码" prop="mobile" >
				<el-input placeholder="手机号码" v-model="post.mobile" class="w-200"></el-input>
			</el-form-item>
			<el-form-item label="绑定微信用户" >
				<el-select v-model="post.uid" filterable remote clearable :remote-method="user_search" :loading="is_loading">
					<el-option v-for="(val,key) in list" :key="key" :value="val.id" :label="val.nickname">
						<div class="o-user">
							<div class="o-avatarurl" :style="{ backgroundImage:'url('+val.avatarurl+')' }"></div>
							<div class="o-nickname">{{val.nickname}}</div>
						</div>
					</el-option>
				</el-select>
			</el-form-item>
<!--			<el-form-item label="接收信息">
				<el-switch v-model="post.is_message" active-text="接收" inactive-text="不接收" active-value="1" inactive-value="0"></el-switch>
			</el-form-item>-->
			<el-form-item label="超级管理员">
				<el-switch v-model="post.is_admin" active-text="超级管理员" inactive-text="普通管理员" active-value="1" inactive-value="0"></el-switch>
			</el-form-item>
<!--			<el-form-item label="权限设置" v-if="post.is_admin==0">
				<div class="p-list" v-for="(val,key) in permission" :key="key">
					<div class="p-main">
						<el-switch v-model="post.permission[val.type]" :active-text="val.name"></el-switch>
					</div>
					<div class="p-items" v-if="val.sub_menu && post.permission[val.type]">
						<div class="p-item" v-for="(sval,skey) in val.sub_menu" :key="skey">
							<el-switch v-model="post.permission[val.type+'_'+sval.type]" :active-text="sval.name"></el-switch>
						</div>
					</div>
				</div>
			</el-form-item>-->
			<el-form-item>
				<el-button type="primary" @click="submit">确定提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		name : "admin-add-edit",
		props : {
			aid : { type : [Number,String], default:0}
		},
		data (){
			return {
				rules : {
					username : [{required : true, message : '请填写', trigger : 'blur'}],
				},
				post : {
					id : 0,
					username : '',
					password : '',
					realname : '',
					mobile : '',
					uid : '',
					is_admin : 0,
					permission : {},
					is_message : 0,
				},
				permission : [],
				list : [],
				is_loading : false,
			}
		},
		mounted : async function(){
			try{
				// await this.get_permission();
				if (this.aid){
					let res = await this.$_api.admin('get_for_post', {id : this.aid});
					if (res.errcode == 0){
						this.post = res.post;
						if (res.post.uid){
							let res_list = await this.$_api.admin('get_for_list', {uid : res.post.uid});
							if (res_list.errcode == 0){
								this.list = res_list.list;
							}
						}
					}
				}
			}catch (e){
				console.log(e);
				return false;
			}
		},
		methods : {
			get_permission : async function  (){
				try{
					let res = await this.$_api.admin('get_permission');
					if (res.errcode == 0){
						this.permission = res.permission;
					}
				}catch (e){
					console.log(e);
					return false;
				}
			},
			user_search : async function (e){
				try{
					console.log(e);
					this.is_loading = true;
					let res = await this.$_api.admin('get_user_list', {keyword : e});
					this.is_loading = false;
					if (res.errcode == 0){
						this.list = res.list;
					}
				}catch (e){
					console.log(e);
					return false;
				}
			},
			submit : async function  (){
				try{
					let that = this;
					let post = this.post;
					if (post.id == 0){
						if (!post.password){
							this.$_showToastNone('请填写密码');
							return ;
						}
					}
					// if (post.is_admin == 0){
					// 	if (Object.keys(post.permission).length == 0){
					// 		this.$_showToastNone('请设置权限');
					// 		return ;
					// 	}
					// }
					this.$refs.post.validate(async function  (check){
						if (check){
							that.$_showLoading();
							if (post.is_admin == 1){
								post['permission'] = [];
							}
							let res = await that.$_api.admin('add', that.post);
							that.$_hideLoading();
							if (res.errcode == 0){
								that.$_showToast(res.errmsg);
								setTimeout(function  (){
									that.$emit('submit',false);
								},1500);
							}else{
								that.$_showToastNone(res.errmsg);
							}
						}
					},)
				}catch (e){
					console.log(e);
					return false;
				}
			},
		},
	}
</script>

<style scoped>
	.p-list { border: 1px solid #dcdfe6; padding: 10px 20px; margin-bottom: 20px; }
	.p-main { width: 100%; }
	.p-items { width: 100%; }
	.p-items:after { content: ''; display: table; clear: both; }
	.p-item { float: left; margin-top: 10px; margin-right: 15px; }
	
	.o-user { height: 34px; display: flex; overflow-x: hidden; }
	.o-avatarurl { width: 34px; height: 34px; border-radius: 17px; overflow-x: hidden; background: transparent no-repeat center; background-size: cover; }
	.o-nickname { flex: 1; padding-left: 10px; }
</style>
